module.exports = __webpack_public_path__ + "media/images/icon-arrow-back-orange-b843b3d375a666a012605d7cb9297662.png";